import { ClickAwayListener } from "@mui/material";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isPublicPage } from "@/utils/visualBuilder";

import FormTextField from "../../../../components/UI/FormTextField";
import { getContacts, resetContacts } from "../../../../store/actions";
import { contactsSelector } from "../../../../store/selectors";

export default function ShareContactField(props) {
  const { classes, propertyId, control, values, setValue, trigger, tabStatus, organizationId } = props;

  const dispatch = useDispatch();
  const timer = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const isPublic = isPublicPage(tabStatus);

  const { contacts = [] } = useSelector(
    contactsSelector({
      ...(organizationId ? { organizationId } : { propertyId }),
    }),
  );

  const fetchContacts = (text) => {
    if (text && text.length > 2) {
      const query = {
        searchText: text,
        offset: 0,
        limit: 5,
      };
      if (organizationId) {
        dispatch(getContacts({ organizationId, query }));
      } else {
        dispatch(getContacts({ propertyId, query }));
      }
    } else {
      if (organizationId) {
        dispatch(resetContacts({ organizationId }));
      } else {
        dispatch(resetContacts({ propertyId }));
      }
    }
  };

  const handleChange = async (value) => {
    setShowMessage(false);

    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(async () => {
      if (!isPublic) {
        fetchContacts(value);
        setIsOpen(true);
      }

      setValue("email", value);
      setValue("phone", value);
      setValue("contactId", null);
      setShowMessage(true);

      await trigger();
    }, 300);
  };

  const onContactClick = async (contactId, field, value) => {
    setValue("contactId", contactId);
    setValue("contactField", value);
    setValue("email", "");
    setValue("phone", "");

    if (field === "email") {
      setValue("email", value);
    }

    if (field === "phone") {
      setValue("phone", value);
    }
    setIsOpen(false);

    await trigger();
  };

  return (
    <div className={classes.formControl} data-testid="share-contact-field-container">
      <FormTextField
        name="contactField"
        control={control}
        label={isPublic ? "Enter phone or email" : "Enter contact name, phone or email"}
        variant="standard"
        fullWidth
        autoComplete="off"
        classes={{ root: classes.textField }}
        onFocus={() => {
          if (!isPublic) {
            dispatch(
              resetContacts({
                ...(organizationId ? { organizationId } : { propertyId }),
              }),
            );
            fetchContacts(values.contactField);
            setIsOpen(true);
          }
        }}
        onBlur={() => setShowMessage(true)}
        onChange={(value) => handleChange(value)}
        hideErrMessage={!showMessage || (isOpen && values.contactField.length > 2 && !!contacts.length)}
      />
      {isOpen && !isPublic && values.contactField.length > 2 && !!contacts.length && (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
          <ul className={classes.contactList}>
            {contacts.map((contact) => (
              <li className={classes.contactListItem} key={`contact-${contact.id}`}>
                <span className={classes.contactListItemTitle}>{contact.name || "<em>Unnamed</em>"}</span>
                <span
                  className={classes.contactListItemText}
                  onClick={() => onContactClick(contact.id, "email", contact.email)}
                >
                  {contact.email}
                </span>
                <span
                  className={classes.contactListItemText}
                  onClick={() => onContactClick(contact.id, "phone", `${contact.phone.code}${contact.phone.number}`)}
                >
                  {contact.phone.code}
                  {contact.phone.number}
                </span>
              </li>
            ))}
          </ul>
        </ClickAwayListener>
      )}
    </div>
  );
}
